import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { JwPaginationComponent } from 'jw-angular-pagination';

import { SharedModule } from '../shared/shared.module';
import { CalendarModule } from 'angular-calendar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FooterComponent } from '../main-layout/footer/footer.component';
import { BasicTableComponent } from './tables/basic-table/basic-table.component';
import { ModalsComponent } from './modals/modals.component';
import { StatsCardComponent } from './common/stats-card/stats-card.component';
import { StatsCard2Component } from './common/stats-card2/stats-card2.component';
import { DashboardComponent } from './dashboards/dashboard/dashboard.component';
import { HelpComponent } from './help/help.component';
import { LoginComponent } from './login/login.component';
import { TermsOfServiceComponent } from './legal/terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './legal/privacy-policy/privacy-policy.component';
import { PasswordResetComponent } from './login/password-reset/password-reset/password-reset.component';
import { ConfirmPasswordResetComponent } from './login/confirm-password-reset/confirm-password-reset/confirm-password-reset.component';
import { ConfirmRegistrationComponent } from './login/confirm-registration/confirm-registration.component';
import { TradePlanningComponent } from './transactions/trade-planning/trade-planning.component';
import { SettingsComponent } from './account/settings/settings.component';
import { BrokerSettingsComponent } from './account/broker-settings/broker-settings.component';
import { BrokerAccountComponent } from './account/broker-account/broker-account.component';
import { FiaComponent } from './fia/fia/fia.component';
import { MarketTradesComponent } from './marketTrades/market-trades/market-trades.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { NewUserModalComponent } from './common/new-user-modal/new-user-modal.component';
import { UserProfileModalComponent } from './common/user-profile-modal/user-profile-modal.component';
import { FiaApplicationComponent } from './common/fia-application/fia-application.component';
import { FiaPinsComponent } from './common/fia-pins/fia-pins.component';
import { FiaDocumentsComponent } from './common/fia-documents/fia-documents.component';
import { TablePaginationComponent } from './common/table-pagination/table-pagination.component';
import { TradesInProgressComponent } from './transactions/trades-in-progress/trades-in-progress.component';
import { FiaApplicationsComponent } from './common/fia-applications/fia-applications.component';
import { UserDocumentsComponent } from './common/user-documents/user-documents.component';
import { UserFiaPinComponent } from './common/user-fia-pin/user-fia-pin.component';
import { UserSummaryComponent } from './common/user-summary/user-summary.component';
import { UserTradesComponent } from './common/user-trades/user-trades.component';
import { ToolsComponent } from './tools/tools.component';
import { FilterPipe } from '../pipes/filter.pipe';
import { SortDirective } from '../directives/sort.directive';
import { TradeEditComponent } from './transactions/trade-edit/trade-edit.component';
import { WorkbenchComponent } from './tools/workbench/workbench.component';
import { PublicHolidaysComponent } from './tools/public-holidays/public-holidays.component';
import { AitComponent } from './ait/ait.component';
import { CheckListComponent } from './transactions/trade-planning/checklist/checklist.component';
import { TagsComponent } from './common/tags/tags.component';
import { TagsEditorComponent } from './common/tags/tags-editor/tags-editor.component';
import { AddNewTradeComponent } from './transactions/add-new-trade/add-new-trade.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { CategoriesStepsComponent } from './onboarding/categories-steps/categories-steps.component';
import { OffboardingComponent } from './offboarding/offboarding.component';
import { OffboardingCategoriesStepsComponent } from './offboarding/categories-steps/offboarding-categories-steps.component';
import { OffboardingNotesComponent } from './offboarding/notes/offboarding-notes.component';
import { DocumentComponent } from './common/user-documents/documents/document.component';
import { UserKycProfileComponent } from './onboarding/user-kyc-profile/user-kyc-profile.component';
import { CreateDocumentComponent } from './common/user-documents/documents/create-document/create-document.component';
import { CurrentTradesComponent } from './transactions/current-trades/current-trades.component';
import { SdaReservedComponent } from './common/user-profile-modal/sda/sda-reserved.component';
import { FiaReservedComponent } from './common/user-profile-modal/fia/fia-reserved.component';
import { TransactionFiaSdaEditComponent } from './transactions/transaction-fia-sda-edit/transaction-fia-sda-edit.component';
import { SqlReportsComponent } from './reports/sql-reports/sql-reports.component';
import { WealthOnboardingComponent } from './wealth-onboarding/wealth-onboarding.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    BrowserModule,
    CalendarModule,
    SharedModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    NgbModule,
    ReactiveFormsModule,
  ],
  declarations: [
    FooterComponent,
    BasicTableComponent,
    ModalsComponent,
    StatsCardComponent,
    StatsCard2Component,
    DashboardComponent,
    HelpComponent,
    LoginComponent,
    TermsOfServiceComponent,
    PrivacyPolicyComponent,
    PasswordResetComponent,
    ConfirmPasswordResetComponent,
    ConfirmRegistrationComponent,
    TradePlanningComponent,
    SettingsComponent,
    BrokerAccountComponent,
    BrokerSettingsComponent,
    FiaComponent,
    MarketTradesComponent,
    UserManagementComponent,
    NewUserModalComponent,
    UserProfileModalComponent,
    FiaApplicationComponent,
    FiaPinsComponent,
    FiaDocumentsComponent,
    TablePaginationComponent,
    TradesInProgressComponent,
    FiaApplicationsComponent,
    UserDocumentsComponent,
    UserFiaPinComponent,
    UserSummaryComponent,
    UserTradesComponent,
    ToolsComponent,
    FilterPipe,
    SortDirective,
    TradeEditComponent,
    WorkbenchComponent,
    PublicHolidaysComponent,
    AitComponent,
    CheckListComponent,
    TagsComponent,
    TagsEditorComponent,
    AddNewTradeComponent,
    OnboardingComponent,
    CategoriesStepsComponent,
    OffboardingComponent,
    OffboardingCategoriesStepsComponent,
    OffboardingNotesComponent,
    DocumentComponent,
    UserKycProfileComponent,
    CreateDocumentComponent,
    CurrentTradesComponent,
    SdaReservedComponent,
    FiaReservedComponent,
    TransactionFiaSdaEditComponent,
    SqlReportsComponent,
    WealthOnboardingComponent,
  ],
  exports: [
    FooterComponent,
    BasicTableComponent,
    ModalsComponent,
    StatsCardComponent,
    StatsCard2Component,
    DashboardComponent,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    BrowserAnimationsModule,
    NgbModule,
    TradeEditComponent,
  ],
  providers: [MatDatepickerModule, NgbActiveModal, DatePipe, DecimalPipe],
  entryComponents: [NewUserModalComponent, UserProfileModalComponent, FiaApplicationComponent, FiaPinsComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ViewsModule {}
